import { useState } from 'react';

import { useAppDispatch } from '@/shared/hooks';

import { reportsModel, useCheckReportSignature } from '@/entities/reports';

export const useResetTooth = (toothID: string) => {
  const [isResetToothLoading, setResetToothLoading] = useState(false);

  const dispatch = useAppDispatch();

  const { checkReportSignature } = useCheckReportSignature();

  const resetTooth = () => {
    checkReportSignature({
      toothID,
      onSignatureChecked: async () => {
        setResetToothLoading(true);

        try {
          await dispatch(
            reportsModel.thunks.resetReportTooth({
              ToothID: toothID,
            }),
          );
        } finally {
          setResetToothLoading(false);
        }
      },
    });
  };

  return { resetTooth, isResetToothLoading };
};
